/*----- Imports -----*/
import React       from 'react'
import styled, { css }      from 'styled-components'
import PropTypes   from 'prop-types'
import { NavLink } from 'react-router-dom'

/*----- Commons-----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color      from '../../commons/Color'

/*----- Styles-----*/
const StyledNavButton = styled(NavLink)`
	${ Montserrat(14, 500, Color.tertiary) };
	display: flex;
	align-items: center;
	text-decoration: none;
	text-transform: capitalize;
	height: 46px;
	padding: 0 20px;
	min-width: 100px;
	justify-content: center;
	max-width: 200px;
	border: none;
	transition: all 0.3s ease-out;
	&:focus {
		outline: none;
	}
	&:hover {
		box-shadow: inset 0px -1px 0px 0px ${Color.main};
		color: ${Color.main};
	}
	${props => props.selected && css`
		color: ${Color.tertiary};
		box-shadow: inset 0px -4px 0px 0px ${Color.main};
  `}
`

/*----- Component -----*/
const NavButton = ({ content, destination, selected}) => (
	<StyledNavButton className="nav-button" to={destination} selected={selected}> 
		{ content }
	</StyledNavButton>
)
export default NavButton

/*----- PropTypes -----*/
NavButton.propTypes = {
  content:	 		PropTypes.string.isRequired,
  destination:	PropTypes.string.isRequired
}
